"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.unableToConsumeToken = exports.resultOrError = exports.betterError = void 0;
function betterError(e1, e2) {
    if (e1 === undefined) {
        return e2;
    }
    if (e2 === undefined) {
        return e1;
    }
    if (e1.pos === undefined) {
        return e1;
    }
    if (e2.pos === undefined) {
        return e2;
    }
    if (e1.pos.index < e2.pos.index) {
        return e2;
    }
    else if (e1.pos.index > e2.pos.index) {
        return e1;
    }
    else {
        return e1;
    }
}
exports.betterError = betterError;
function resultOrError(result, error, successful) {
    if (successful) {
        return {
            candidates: result,
            successful: true,
            error: error
        };
    }
    else {
        return {
            successful: false,
            error: error
        };
    }
}
exports.resultOrError = resultOrError;
function unableToConsumeToken(token) {
    return {
        kind: 'Error',
        pos: token === undefined ? undefined : token.pos,
        message: "Unable to consume token: " + (token === undefined ? '<END-OF-FILE>' : token.text)
    };
}
exports.unableToConsumeToken = unableToConsumeToken;
//# sourceMappingURL=ParserInterface.js.map